import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
import { ProductsReducer, ProductReducer } from "./reducer/product_reducer";
import { CartReducer } from "./reducer/cart_reducer";
import BadgeReducer from "./reducer/badge_reducer";
import { composeWithDevTools } from "redux-devtools-extension";

const reducer = combineReducers({
  productList: ProductsReducer,
  product: ProductReducer,
  cart: CartReducer,
  badge: BadgeReducer,
});
const cartLocalStorage = localStorage.getItem("cartItems")
  ? JSON.parse(localStorage.getItem("cartItems"))
  : [];

const initialState = {
  cart: { cartItems: cartLocalStorage },
};
const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);
export default store;

// test9
